import { SPEECH_LOCALES, type SpeechLanguage } from '@itsappy/shared';

/**
 * Which language the browser's own speech recogniser should listen for.
 *
 * Only consulted where there is no server transcription provider. The
 * provider detects the language from the audio; `SpeechRecognition` cannot —
 * it is handed exactly one language and hears everything as that, so Arabic
 * spoken into a recogniser set to English comes back as English words nobody
 * said. That failure is silent, and the transcript is what everyone who
 * cannot play the note will read.
 *
 * Kept apart from the shell's language on purpose. Which language the buttons
 * are in says nothing about which language the person speaks — an English
 * interface is the normal setting for someone who dictates in Arabic, which
 * is exactly how this was found.
 */
const KEY = 'itsappy.dictationLanguage';

export function dictationLanguage(): SpeechLanguage {
  const stored = localStorage.getItem(KEY);
  if (stored === 'ar' || stored === 'en') return stored;
  // Unset: the shell's language is a poor guess but the only one available,
  // and the control that overrides it sits next to the microphone.
  return document.documentElement.lang === 'ar' ? 'ar' : 'en';
}

export function setDictationLanguage(language: SpeechLanguage): void {
  localStorage.setItem(KEY, language);
}

/** The BCP-47 tag for the stored choice. */
export function dictationLocale(): string {
  return SPEECH_LOCALES[dictationLanguage()];
}
